@if (initialized) {
  @if (!account.hasPicture) {
    <div class="profile-char" [style.width]="size" [style.height]="size">
      {{account.profileChar}}
    </div>
  }
  @if (account.hasPicture) {
    <div class="profile-pic" [style.width]="size" [style.height]="size">
      <img [src]="account.picture?.thumb_url" alt="{{account.name}} profile picture" />
    </div>
  }
}
